export const validateName = (name: string) => {
  if (!name.trim()) {
    return 'Name is required'
  }
  return null
}

export const validateMessage = (message: string) => {
  if (!message.trim()) {
    return 'Message is required'
  }
  return null
}

export const validatePhoneNumber = (phone: string) => {
  if (!phone.trim()) {
    return 'Phone Number is required'
  }
  const regex =
    /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g
  if (!regex.test(phone) || phone.length !== 10) {
    return 'Enter a valid phone number'
  }
  return null
}

export const validateEmail = (email: string) => {
  if (!email.trim()) {
    return 'Email is required'
  }
  const regex =
    /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/gm
  if (!regex.test(email)) {
    return 'Enter valid Email'
  }
  return null
}

export const validateSelectQuery = (queryType: string) => {
  if (!queryType.trim()) {
    return 'Query type is required'
  }
  return null
}
